import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    IconButton,
    Tooltip,
    Typography
} from '@mui/material';
import { useState } from 'react';
import { cancelButtonStyle } from '../../../style';
import NotesIcon from '@mui/icons-material/Notes';
import theme from '../../../theme';
import { useScreenSmallerThan } from '../../../lib/hooks/breakpoint-hooks';

interface ModalProps {
    notes: string;
}

const NotesReadOnlyModal = ({ notes }: ModalProps) => {
    const isSmallerThanSmall = useScreenSmallerThan('sm');
    const [isDialogOpened, setDialogOpened] = useState(false);
    const handleCloseDialog = () => setDialogOpened(false);
    const handleOpenDialog = () => setDialogOpened(true);

    const anyNotesAvailable = notes !== null && notes !== '';

    return (
        <>
            <Tooltip title={!isSmallerThanSmall ? notes : ''}>
                <IconButton
                    aria-label="delete"
                    onClick={handleOpenDialog}
                    disableRipple={true}
                    sx={{
                        // display: notes === '' && !isSmallerThanSmall ? 'none' : 'auto',
                        color: !anyNotesAvailable
                            ? theme.palette.cardSubtitle.main
                            : theme.palette.primary.main
                    }}>
                    <NotesIcon />
                    {isSmallerThanSmall && <Typography pl={'0.525rem'}>Notes</Typography>}
                </IconButton>
            </Tooltip>
            <Dialog
                open={isDialogOpened && isSmallerThanSmall && anyNotesAvailable}
                onClose={handleCloseDialog}>
                <DialogTitle variant="h3">Notes</DialogTitle>
                <DialogContent sx={{ minWidth: '15rem', maxWidth: '31.25rem' }}>
                    <Typography variant="h6">{notes}</Typography>
                </DialogContent>
                <DialogActions sx={{ paddingRight: '1.5rem', paddingLeft: '1.5rem' }}>
                    <Button sx={cancelButtonStyle} onClick={handleCloseDialog}>
                        Close
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};
export default NotesReadOnlyModal;
